import React from 'react'

import Nav from '../components/Nav'
import Header from '../containers/Header'
import Location from '../containers/Locations'
import Control from '../containers/Control'
import Analyze from '../containers/Analyze'
import Requirements from '../containers/Requirements'
import Devices from '../containers/Devices'
import Cta from '../containers/Cta'
import Footer from '../components/Footer'

const Main = () => (
  <div>
    <Nav />
    <Header />
    <Location />
    <Control />
    <Analyze />
    <Requirements />
    <Devices />
    <Cta />
    <Footer />
  </div>
)

export default Main



// WEBPACK FOOTER //
// ./screens/Main.js